import { render, staticRenderFns } from "./SectionCTA.vue?vue&type=template&id=10816688"
import script from "./SectionCTA.vue?vue&type=script&lang=js"
export * from "./SectionCTA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports